import React from 'react';

export const Cross = ({ color = '#284E80', className = '', size = 24, ...restProps }) => (
  <svg width={size} height={size} viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1.70711" y1="1.29289" x2="41.7071" y2="41.2929" stroke="black" strokeWidth="2" />
    <line x1="1.29289" y1="41.2929" x2="41.2929" y2="1.29289" stroke="black" strokeWidth="2" />
  </svg>
);
